module.exports = __webpack_public_path__ + "img/xglhc_icon.113d1bd0.png";